// extracted by mini-css-extract-plugin
export default {"wrapper":"PngItem_wrapper__bW4Gs","wrapperIcon":"PngItem_wrapperIcon__iJrGv","png":"PngItem_png__tejHx"};